import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElasticComponent } from './simple-icons-elastic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElasticComponent ],
    exports:      [ SimpleIconsElasticComponent ],
    bootstrap:    []
})
export class SimpleIconsElasticModule {}
